import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { FC } from 'react'
import styled from 'styled-components'

interface Props {
  value: string
  name: string
  icon?: IconDefinition
  className?: string
  onChange: () => void
  checked: boolean
  disabled?: boolean
}

const StyledInput = styled.input`
  margin: 0;
`

const Container = styled.div<{ disabled?: boolean }>`
  display: grid;
  grid-template-columns: min-content min-content 1fr;
  gap: 10px;
  align-items: center;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  & > * > * {
    cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  }
`

const StyledDetailContainer = styled.div<{ disabled?: boolean }>`
  opacity: ${props => (props.disabled ? '0.3' : '1')};
`

const RadioInput: FC<Props> = ({
  name,
  icon,
  value,
  children,
  className,
  onChange,
  checked,
  disabled,
}) => {
  const onChangeCallback = disabled ? () => {} : onChange

  return (
    <Container className={className} onClick={onChangeCallback} disabled={disabled}>
      <StyledInput
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChangeCallback}
        disabled={disabled}
      />
      <StyledDetailContainer disabled={disabled}>
        {icon && <FontAwesomeIcon size="1x" icon={icon} />}
      </StyledDetailContainer>
      <StyledDetailContainer disabled={disabled}>
        <label htmlFor={value}>{children}</label>
      </StyledDetailContainer>
    </Container>
  )
}

export default RadioInput
